import { shellCopy } from '@/copy'
import { Text } from '@/ui/layout/Text'
import { SegmentedControl } from '@/ui/SegmentedControl/SegmentedControl'
import { TEXT_SIZES, type TextSizeId } from '../store/appearance'

// D38: the preview's 14/16/18 are these roles at the default size
const PREVIEW_ROLE = { sm: 'caption', md: 'ui', lg: 'prose' } as const

const OPTIONS = TEXT_SIZES.map((size) => ({
  value: size.id,
  label: size.label,
  preview: (
    <Text as="span" variant={PREVIEW_ROLE[size.id]}>
      {shellCopy.appearance.textSample}
    </Text>
  ),
}))

export function TextSizePicker({
  value,
  onChange,
}: {
  value: TextSizeId
  onChange: (value: TextSizeId) => void
}) {
  return (
    <SegmentedControl
      label={shellCopy.appearance.textSize}
      value={value}
      options={OPTIONS}
      onChange={onChange}
    />
  )
}
